module.exports = __webpack_public_path__ + "img/footer-logos.45fb6907.png";